import "react";
import { jsx as e } from "react/jsx-runtime";
//#region src/components/atoms/Icon/SVGs/arrowRight.svg
var t = (t) => /* @__PURE__ */ e("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 17 16",
	...t,
	children: /* @__PURE__ */ e("path", {
		fill: "#1f2830",
		d: "M6.843.46a.94.94 0 0 0 .085 1.33l5.643 4.965a.167.167 0 0 1-.11.292H.957a.941.941 0 1 0 0 1.883H12.46a.167.167 0 0 1 .111.292l-5.643 4.967A.942.942 0 1 0 8.173 15.6l7.31-6.435a1.57 1.57 0 0 0 0-2.356L8.174.375a.94.94 0 0 0-1.33.085"
	})
});
//#endregion
export { t as default };
